import { type ReactElement, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { logEvent, useLogBigQueryEvent } from '@/features/analytics';
import { useExperiment } from '@/features/experiment';
import { appConfig } from '@/providers/config';

import { AltSignUpForm } from '../containers/AltSignUpForm/AltSignUpForm';
import { SignUpForm } from '../containers/SignUpForm/SignUpForm';

export function RegisterRoute(): ReactElement {
  const { logBigQueryEvent } = useLogBigQueryEvent();
  const { experiment } = useExperiment();

  useEffect(() => {
    logBigQueryEvent('lnd_register');
  }, [logBigQueryEvent]);

  useEffect(() => {
    logEvent('lnd_register');
  }, []);

  return (
    <>
      <Helmet>
        <title>Sign Up - {appConfig.name}</title>
      </Helmet>

      {experiment === 'current-flow' ? <SignUpForm /> : <AltSignUpForm />}
    </>
  );
}
